var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"gap"}},[_vm._t("bt_purchase"),_vm._m(0)],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container lazyload"},[_c('p',[_c('span',[_vm._v("JJ ENGLISH エクササイズは"),_c('br'),_vm._v("日本の学校でしか英語を学んだことがない…")]),_vm._v("でも、本気で話したい人に向けて開発された"),_c('br'),_vm._v(" 特別な英会話教材です。")])])
}]

export { render, staticRenderFns }